import React, { useMemo } from "react";
import { Layout, Menu, Drawer } from "antd";
import { checkMobile } from "../../common/utils/utils-device";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const { Sider } = Layout;

const MenuDrawer = () => {
  const { pathname } = useLocation();
  const roles = useSelector((state) => (state.auth ? state.auth.roles : []));

  const isCustommer = useMemo(() => roles.includes("Customer"), [roles]);

  return (
    <Menu mode="inline">
      <Menu.Item
        key="/notification"
        icon={
          <img
            alt=""
            className="anticon anticon-desktop"
            style={styles.icon}
            src={require("../../assets/icons/bell-solid.png")}
          />
        }
        className={pathname === "/notification" ? "activeBackground" : ""}
      >
        <Link style={{ color: "#fff" }} to="/notification">
          Danh sách thông báo
        </Link>
      </Menu.Item>

      {isCustommer && (
        <Menu.Item
          key="/journey-diary"
          icon={
            <img
              alt=""
              style={{ ...styles.icon, width: "1.5em", height: "unset" }}
              className="anticon anticon-desktop"
              src={require("../../assets/icons/journey-diary.png")}
            />
          }
          className={pathname === "/journey-diary" ? "activeBackground" : ""}
        >
          <Link style={{ color: "#fff" }} to="/journey-diary">
            Nhật ký hành trình
          </Link>
        </Menu.Item>
      )}

      <Menu.Item
        key="/customer-pr"
        icon={
          <img
            alt=""
            style={{ ...styles.icon, width: "1.5em", height: "unset" }}
            className="anticon anticon-desktop"
            src={require("../../assets/icons/journey-diary.png")}
          />
        }
        className={pathname === "/customer-pr" ? "activeBackground" : ""}
      >
        <Link style={{ color: "#fff" }} to="/customer-pr">
          Payment Request
        </Link>
      </Menu.Item>
      <Menu.Item
        key="/customer-review"
        icon={
          <img
            alt=""
            style={{ ...styles.icon, width: "1.5em", height: "unset" }}
            className="anticon anticon-desktop"
            src={require("../../assets/icons/star.png")}
          />
        }
        className={pathname === "/customer-review" ? "activeBackground" : ""}
      >
        <Link style={{ color: "#fff" }} to="/customer-review">
          Nhận xét đánh giá
        </Link>
      </Menu.Item>
    </Menu>
  );
};

export const CustomerSideBar = ({ onCollapse, setOnCollapse }) => {
  if (checkMobile() || window.innerWidth <= 997) {
    return (
      <Drawer
        title="DRAW"
        placement={"left"}
        closable={false}
        onClose={() => setOnCollapse(false)}
        visible={onCollapse}
      >
        <MenuDrawer />
      </Drawer>
    );
  }

  return (
    <div className="content">
      <Sider
        collapsedWidth={0}
        className="site-layout-background"
        width={280}
        collapsible
        collapsed={onCollapse}
      >
        <MenuDrawer />
      </Sider>
    </div>
  );
};

const styles = {
  icon: {
    width: "1.3em",
    height: "1.3em",
    marginRight: 25,
    objectFit: "contain",
  },
};
